// Reine Konstanten der Gruppen (ohne Datenbank, ohne Node-Module) — Server UND Oberfläche importieren dieselbe Liste.
export const OHNE_BUCHUNGSART = "ohne Buchungsart";
export const OHNE_GRUPPE = "ohne Gruppe (nachrichtlich)";
/** Reihenfolge der Gruppen in der Anzeige (Entwurf Abschnitt C), danach die beiden Sammeltöpfe. */
export const GRUPPEN_REIHENFOLGE = [
  "§18 Geschäftlich",
  "§19 Anstellung",
  "§21/35a Vermietung/Haus",
  "§22/23 Privatverkauf",
  "§33 Gesundheit",
  "§10 Sonderausgaben", // seit 25.10.2026 (User): § 10b Spenden & Mitgliedsbeiträge ab 2025 — Abweichung von der Steuerdatei
  "§12 Privat",
  "Neutral/durchlaufend",
  OHNE_GRUPPE,
  OHNE_BUCHUNGSART,
] as const;

export function gruppenRang(g: string): number {
  const i = (GRUPPEN_REIHENFOLGE as readonly string[]).indexOf(g);
  return i === -1 ? 50 : i;
}
